export default {
  // Page titles
  'dashboard.title': 'Operations Dashboard',
  'dashboard.subtitle': 'Here you can configure parameters and execute various product synchronization, inventory management, order processing and other operations.',
  
  // Statistics cards
  'dashboard.stats.categories': 'Categories',
  'dashboard.stats.tasks': 'Total Tasks',
  'dashboard.stats.running': 'Running',
  'dashboard.stats.completed': 'Completed',
  
  // Category names
  'dashboard.category.product': 'Product Management',
  'dashboard.category.order': 'Order Management',
  'dashboard.category.dear': 'DEAR Data Tracking',
  'dashboard.category.others': 'Others',
  'dashboard.common.operations': 'Common Operations',
  
  // Task names
  'dashboard.task.product.status.check': 'Check Product Status',
  'dashboard.task.product.sync': 'Product Sync',
  'dashboard.task.product.price.sync': 'Price Sync',
  'dashboard.task.product.stock': 'Stock Sync',
  'dashboard.task.product.image': 'Image Sync',
  'dashboard.task.product.grouping.sync': 'Grouping Sync',
  'dashboard.task.product.duplicate.check': 'Check Duplicates',
  'dashboard.task.product.unpublish': 'Unpublish Invalid Products',
  'dashboard.task.product.clean.unbound': 'Clean Unbound Products',
  'dashboard.task.product.delete': 'Delete Product Variants',
  'dashboard.task.product.backup': 'Backup Products',
  'dashboard.task.product.dear.manual.sync': 'Manual DEAR Sync',
  'dashboard.task.product.dear.unpublish.check': 'Manual Unpublish Check',
  'dashboard.task.product.dear.sync.barcode': 'Sync by Barcode',
  'dashboard.task.product.dear.backfeed': 'DEAR Backfeed Sync',
  'dashboard.task.product.media.check': 'Media Check',
  'dashboard.task.product.sync.hscode': 'Sync HS Code',
  'dashboard.task.product.merge.reviews': 'Merge Reviews',
  'dashboard.task.product.cloudinary.task': 'Image Sync Task',
  'dashboard.task.order.sync': 'Order Sync',
  'dashboard.task.order.status.check': 'Check Order Status',
  'dashboard.task.order.push': 'Push Order to DEAR',
  'dashboard.product.sync.progress.title': 'Product sync in progress',
  'dashboard.async.task.progress.title': 'Background task in progress',
  'dashboard.async.progress.phase.media': 'Media sync',
  'dashboard.async.progress.phase.grouping': 'Grouping sync',
  'dashboard.async.progress.phase.stock': 'Stock sync',
  'dashboard.async.progress.phase.status_check': 'Status check',
  'dashboard.async.progress.phase.unpublish': 'Unpublish check',
  'dashboard.async.progress.phase.cleanup': 'Clean unbound',
  'dashboard.async.progress.phase.duplicate_check': 'Duplicate check',
  'dashboard.async.progress.phase.sync': 'Sync',
  'dashboard.image.sync.progress.phase.media': 'Media sync',
  'dashboard.image.sync.progress.phase.grouping': 'Grouping sync',
  'dashboard.product.sync.progress.total': 'Total',
  'dashboard.product.sync.progress.processed': 'Processed',
  'dashboard.product.sync.progress.succeeded': 'Succeeded',
  'dashboard.product.sync.progress.failed': 'Failed',
  'dashboard.product.sync.duplicate': 'An identical task is already running; showing existing progress',
  'dashboard.product.sync.cancel.sent': 'Cancel requested; sync will stop after the current step',
  'dashboard.product.sync.cancel.failed': 'Failed to cancel task',
  'dashboard.task.order.migration': 'Shopify Order Migration Import',
  
  // Task descriptions
  'dashboard.desc.product.status.check': 'Check if products meet listing requirements (DEAR status, images, prices, etc.) and automatically handle listing or unlisting based on results. Supports batch processing and specific products, optional to include test products, supports force recheck of unlisted products.',
  'dashboard.desc.product.sync': 'Sync product information from DEAR to Shopify, supports smart and force modes',
  'dashboard.desc.product.price.sync': 'Sync product prices to Shopify, supports smart and force modes',
  'dashboard.desc.product.stock': 'Sync product inventory to Shopify, supports specific barcodes or full sync',
  'dashboard.desc.product.image': 'Sync product images to Shopify, supports smart and force modes',
  'dashboard.desc.product.grouping.sync': 'Update product variant grouping relationships',
  'dashboard.desc.product.duplicate.check': 'Check and handle duplicate products',
  'dashboard.desc.product.unpublish': 'Automatically unpublish products that do not meet requirements',
  'dashboard.desc.product.clean.unbound': 'Clean products not in the index table',
  'dashboard.desc.product.delete': 'Delete specified product variants',
  'dashboard.desc.product.backup': 'Backup product data',
  'dashboard.desc.product.dear.manual.sync': 'Execute DEAR data sync immediately',
  'dashboard.desc.product.dear.unpublish.check': 'Execute automatic unpublish check immediately',
  'dashboard.desc.product.dear.sync.barcode': 'Sync product data for specified barcodes',
  'dashboard.desc.product.dear.backfeed': 'Sync status from Shopify to DEAR, update HSCode',
  'dashboard.desc.product.media.check': 'Check and validate product media files',
  'dashboard.desc.product.sync.hscode': 'Synchronize HS code data for all products',
  'dashboard.desc.product.merge.reviews': 'Merge and consolidate product reviews',
  'dashboard.desc.product.cloudinary.task': 'Run product image sync task (GDrive → Shopify CDN)',
  'dashboard.desc.order.sync': 'Sync orders between systems',
  'dashboard.desc.order.status.check': 'Check and update order status',
  'dashboard.desc.order.push': 'Push the specified order from Shopify to DEAR system.',
  'dashboard.desc.order.migration': 'Upload the DEAR "Shopify Order Migration" xlsx (SaleID in the first column). Runs: ① sync DEAR customers to Shopify (modified in last 30 days) ② fetch each DEAR order by SaleID ③ sync orders to Shopify. Use dry run for the first attempt.',
  'dashboard.order.migration.upload': 'Click or drag xlsx file here',
  'dashboard.order.migration.upload.hint': 'Same format as the email attachment "Query for Shopify Order Migration", first column SaleID',
  'dashboard.order.migration.execute': 'Parse and run migration',
  'dashboard.order.migration.selectFile': 'Please select an xlsx file first',
  'dashboard.order.migration.success.async': 'Parsed {count} SaleID(s). Migration started in the background. Track progress below; a result email will be sent when complete.',
  'dashboard.order.migration.success.async.dryRun': 'Parsed {count} SaleID(s). Migration started in the background (dry run). Track progress below; a result email will be sent when complete.',
  'dashboard.order.migration.progress.title': 'Migration progress',
  'dashboard.order.migration.progress.taskId': 'Task ID',
  'dashboard.order.migration.progress.phase': 'Phase',
  'dashboard.order.migration.progress.status': 'Status',
  'dashboard.order.migration.progress.polling': 'Refreshing…',
  'dashboard.order.migration.progress.done': 'Migration finished',
  'dashboard.order.migration.progress.failed': 'Migration failed',
  'dashboard.order.migration.progress.partial': 'Completed with errors',
  'dashboard.order.migration.col.saleId': 'SaleID',
  'dashboard.order.migration.col.orderNumber': 'Order #',
  'dashboard.order.migration.col.itemStatus': 'Status',
  'dashboard.order.migration.col.message': 'Message',
  'dashboard.order.migration.phase.pending': 'Pending',
  'dashboard.order.migration.phase.customer_sync': 'Syncing customers',
  'dashboard.order.migration.phase.order_sync': 'Syncing orders',
  'dashboard.order.migration.phase.done': 'Done',
  'dashboard.order.migration.item.pending': 'Pending',
  'dashboard.order.migration.item.success': 'Success',
  'dashboard.order.migration.item.dry_run': 'Dry run OK',
  'dashboard.order.migration.item.skipped': 'Skipped',
  'dashboard.order.migration.item.failed': 'Failed',
  'dashboard.order.migration.item.fetch_failed': 'Fetch failed',
  'dashboard.order.migration.item.not_found': 'Not processed',
  'dashboard.order.migration.success.sync': 'Completed full migration for {count} SaleID(s) (customer sync + order fetch + Shopify sync).',
  'dashboard.order.migration.success.sync.dryRun': 'Completed full migration for {count} SaleID(s) (customer sync + order fetch + Shopify sync) (dry run).',
  
  // Buttons and actions
  'dashboard.button.configure': 'Configure and Execute',
  'dashboard.button.execute': 'Execute Task',
  'dashboard.button.cancel': 'Cancel',
  'dashboard.button.confirm': 'Confirm',
  
  // Task status
  'dashboard.status.running': 'Running',
  'dashboard.status.success': 'Success',
  'dashboard.status.failed': 'Failed',
  'dashboard.status.not.executed': 'Not Executed',
  
  // Form labels
  'dashboard.form.barcode': 'Product Barcode',
  'dashboard.form.barcode.placeholder': 'Support multiple separation methods:\n1001,1002,1003\n1001 1002 1003\n1001\n1002\n1003',
  'dashboard.form.barcode.extra': 'Optional: Specify product barcodes, multiple can be separated by comma, space or newline, leave empty to process all products',
  'dashboard.form.order.id': 'Order ID',
  'dashboard.form.order.id.placeholder': 'Enter order ID',
  'dashboard.form.order.id.extra': 'Optional: Specify specific order ID',
  'dashboard.form.order.shopify_id': 'Shopify Order ID',
  'dashboard.form.order.shopify_id.placeholder': 'Enter numeric Shopify order ID, e.g. 6506702471393',
  'dashboard.form.order.shopify_id.extra': 'Required: The numeric ID of the Shopify order',
  'dashboard.form.order.shopify_id.required': 'Please enter a Shopify Order ID',
  'dashboard.form.order.shopify_number': 'Shopify Order Number',
  'dashboard.form.order.shopify_number.placeholder': 'Optional, e.g. #1234',
  'dashboard.form.order.shopify_number.extra': 'Optional: Shopify order number for easier identification',
  'dashboard.form.force.recheck': 'Force recheck unpublished products',
  'dashboard.form.include.test': 'Include test products',
  'dashboard.form.auto.execute': 'Auto execute update',
  'dashboard.form.auto.execute.desc': 'Automatically execute status changes after check',
  'dashboard.form.performance.mode': 'Performance Mode',
  'dashboard.form.performance.mode.extra': 'Select execution mode',
  'dashboard.form.performance.ultra.fast': 'Ultra Fast Mode',
  'dashboard.form.performance.detailed': 'Detailed Mode',
  'dashboard.form.force.reupload': 'Force re-upload all images',
  'dashboard.form.image.sync.scope': 'Sync scope',
  'dashboard.form.image.sync.main': 'Main Images',
  'dashboard.form.image.sync.reference': 'Reference Media',
  'dashboard.form.image.sync.assembly': 'Assembly Manual (PDF)',
  'dashboard.form.image.sync.grouping': 'Grouping',
  'dashboard.form.image.sync.scope.required': 'Please select at least one sync scope',
  'dashboard.form.sync.mode': 'Sync Mode',
  'dashboard.form.sync.mode.extra': 'Select sync mode',
  'dashboard.form.sync.mode.smart': 'Smart Mode',
  'dashboard.form.sync.mode.force': 'Force Mode',
  'dashboard.form.enable.image.sync': 'Enable Image Sync',
  'dashboard.form.concurrent': 'Concurrent execution',
  'dashboard.form.concurrent.desc': 'Improve execution speed',
  'dashboard.form.dry.run': 'Dry Run Mode',
  'dashboard.form.dry.run.desc': 'When enabled, only displays operations to be executed without actually modifying data. Recommended for first-time execution.',
  
  // Confirmation dialog
  'dashboard.confirm.title': 'Confirm Execution',
  'dashboard.confirm.content': 'You are about to execute',
  'dashboard.confirm.warning': 'Warning: This will perform real operations and may modify data!',
  'dashboard.confirm.question': 'Are you sure you want to continue?',
  
  // Messages
  'dashboard.message.success': 'executed successfully',
  'dashboard.message.failed': 'execution failed',
  'dashboard.message.fetch.failed': 'Failed to fetch task list',
  'dashboard.message.loading': 'Loading task list...',
  'dashboard.message.permission.denied': 'Permission denied. You do not have permission to perform this action.',
  
  // Execution results
  'dashboard.results.title': 'Recent Execution Results',
  'dashboard.results.status': 'Status',
  'dashboard.results.success.flag': '✅ Success',
  'dashboard.results.failed.flag': '❌ Failed',
  'dashboard.results.result': 'Result',
  'dashboard.results.error': 'Error',
  
  // Modal
  'dashboard.modal.title': 'Configure Task',
  'dashboard.modal.execution.options': 'Execution Options',
};